<template>
    <v-snackbar v-model="show" :color="color" timeout="3000" top>
      <strong>{{ message }}</strong>
    </v-snackbar>
  </template>
  
  <script setup>
  import { ref, watch } from 'vue';
  
  const props = defineProps({
    show: Boolean,
    color: {
      type: String,
      default: 'info'
    },
    message: String
  });
  
  const emit = defineEmits(['update:show']);
  
  const show = ref(props.show);
  
  watch(() => props.show, (newValue) => {
    show.value = newValue;
  });
  
  function closeSnackbar() {
    show.value = false;
    emit('update:show', false);
  }
  </script>